// src/app/services/router-state-tracker.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { ApiService } from '../provider/api.service';
import { endpoints } from 'src/app/constant/endpoints';
import { ConfigService } from '../provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { BehaviorSubject, first, Observable, Subscription, tap } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService implements OnDestroy {
  private subscription = new Subscription();
  private preferencesSubject = new BehaviorSubject<any>(null);
  public preferences$: Observable<any> = this.preferencesSubject.asObservable();
  private preferences: any;

  private profile: any;
  private settings: any;

  constructor(private router: Router, private navCtrl: NavController, private apiService: ApiService, private configService: ConfigService, private events: Events, private dataService: DataService) {
    this.subscription.add(
      this.configService.appSettings$.subscribe((currentSettings) => {
        this.settings = currentSettings;
      }),
    );
    // Fetch preferences on service initialization
    this.fetchPreferences().subscribe();
  }

  fetchPreferences(): Observable<any> {
    return this.dataService.getData('profile').pipe(
      tap((response: any) => {
        if (response && response.customer) {
          this.profile = response;
          this.preferences = response.customer.preferences;
          this.preferencesSubject.next(this.preferences);
        }
      }),
    );
  }

  updatePreferences(key: string, newValue?: any) {
    // Update the local preferences object first
    if (this.preferences) {
      this.preferences[key] = newValue;
    }

    // Prepare the payload for the API
    const profileFormValue: any = {};
    if (this.profile && this.profile.customer) {
      profileFormValue.customer_id = this.profile.customer.id;
    }
    const jsonString = JSON.stringify(this.preferences);
    Object.assign(profileFormValue, { preferences: jsonString });

    // Send the update to the API
    this.apiService
      .post(endpoints.profile + '/update', profileFormValue)
      .pipe(first())
      .subscribe((response) => {
        console.log(response, 'updated Pref');
        // After a successful API call, force a refresh of the profile data
        this.fetchPreferences().subscribe();
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
